export enum UserMaintenanceActions {
    resentInvite,
    removeUser,
}
